<template>
  <div :class="{ 'iframe-mode': isInIframe }">
    <v-toolbar flat color="white" class="elevation-1">
      <div class="inline-flex w-64">
        <v-select
          class="ml-2 pt-1"
          :items="orderBy"
          clearable
          :placeholder="$t('message.LicensesManager.orderBy')"
          item-text="label"
          item-value="value"
          v-model="columnSelected"
          @change="orderList()"
          solo
          flat
          data-vs-select="orderBy"
        ></v-select>
        <button class="order-button" @click="changeOrderType"  data-vs-button="changeOrder">
          <zt-icon :name="pagination.descending ? 'arrow-down-2': 'arrow-up'" class="pt-2" :class="primaryTextClass" />
        </button>
      </div>
      <v-spacer></v-spacer>
      <zt-button @click="exportData" :loader="exportLoading"  data-vs-button="exportdata" :loaderTxt="$t('message.LicensesManager.search.exportLoading')" outlined icon="box-arrow-down" :disabled="exportLoading">{{ $t('message.LicensesManager.search.export') }}</zt-button>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="this.state.results"
      :expand="expand"
      item-key="id_licencia"
      class="elevation-1"
      :rows-per-page-items="[8, 15, 30]"
      :pagination.sync="pagination"
      @update:pagination="updatePagination"
      :total-items="this.state.total"
      :loading="loading"
      :no-data-text="$t('message.datatable.noDataText')"
    >
      <template v-slot:items="props">
        <tr>
          <td @click="handleExpandRow(props)" class="cursor-pointer"  data-vs-button="expand">
            <zt-icon :name="props.expanded ? 'angle-down': 'angle-right'" />
          </td>
          <td>
            <p
              class="text-zt-base text-zt-dark-500"
            >{{ props.item.nombre }} {{ props.item.apellido }}</p>
          </td>
          <td
            class="text-zt-base text-zt-dark-500"
          >{{ props.item.fecha_desde }} - {{ props.item.fecha_regreso }}</td>
          <td class="text-zt-base text-zt-dark-500">{{ props.item.dias }}</td>
          <td class="text-zt-base text-zt-dark-500">{{ props.item.tipo }}</td>
          <td class="text-zt-base text-zt-dark-500">
            <div :class="setColorByStatus(props.item.id_estado)"></div>
            {{ props.item.estado }}
          </td>
          <td>
            <div class="flex content-center items-center">
                <button
                  @click="openHolidaysModal(props.item)"
                  class="flex align-center mx-1"
                  data-vs-button="openHolidaysModal"
                  v-if="props.item.type_id_vp === '2' && hasVPI"
                >
                  <zt-icon
                    :class="primaryTextClass"
                    class="text-zt-lg pb-1"
                    name="list-ul cursor-pointer"
                  />
                </button>
              </zt-tooltip>
            </div>
          </td>
        </tr>
      </template>
      <template v-slot:expand="props">
        <v-card flat>
          <v-card-text class="pl-16 flex">
            <div class="w-1/2">
              <p>
                <span class="font-bold">{{ $t('message.LicensesManager.search.fileNumber') }}: </span>
                <span class="text-zt-dark-500" v-html="props.item.numero_legajo"></span>
              </p>
              <p>
                <span class="font-bold">{{ $t('message.LicensesManager.search.requestDate') }}: </span>
                <span class="text-zt-dark-500">{{ props.item.fecha | woTime }}</span>
              </p>
              <p>
                <span class="font-bold">{{ $t('message.LicensesManager.search.sector') }}: </span>
                <span class="text-zt-dark-500" v-html="props.item.sector"></span>
              </p>
              <p>
                <span class="font-bold">{{ $t('message.LicensesManager.search.location') }}: </span>
                <span class="text-zt-dark-500" v-html="props.item.locacion"></span>
              </p>
              <p v-if="props.item.observaciones">
                <span
                  class="font-bold"
                >{{ $t("message.LincensesHistorySummaryComponent.labels.comment") }}: </span>
                <span class="text-zt-dark-500" v-html="props.item.observaciones"></span>
              </p>
              <p v-if="props.item_id_estado === 5">
                <span class="font-bold">{{ $t('message.LicensesManager.search.balanceDetail') }}: </span>
                <span class="text-zt-dark-500" v-html="props.item.detalle | parseDetails"></span>
              </p>
              <p v-if="props.item.periodo_liquidacion">
                <span class="font-bold">{{ $t('message.LicensesManager.search.liqPeriod') }}: </span>
                <span class="text-zt-dark-500" v-html="props.item.periodo_liquidacion"></span>
              </p>
            </div>
            <div class="w-1/2 flex flex-col">
              <div v-if="props.item.has_upload_document === 't'" class="text-zt-dark-400 mt-2">
                <template v-if="props.item.license_has_document === 't'">
                  <div class="link" @click="downloadDocument(props.item.id_licencia)">
                    <zt-icon name="file-outline" class="text-zt-xl mx-2"/>
                    <span class="text-zt-lg underline">{{ $t('message.LicensesManager.search.fileUploaded') }}</span>
                  </div>
                </template>
                <template v-else>
                  <zt-icon name="file-quest" class="text-zt-xl mx-2"/>
                  <span class="text-zt-lg underline">{{ $t('message.LicensesManager.search.fileNotUploaded') }}</span>
                </template>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </template>
    </v-data-table>
    <HolidaysByPeriodModal
      :activeModal="activeHolidaysModal"
      :licenceId="selectedItemId"
      @close="activeHolidaysModal = !activeHolidaysModal"
    />
  </div>
</template>

<script>
import Licenses from '@/apiClient/Licenses'
import SichernPeople from '@/apiClient/SichernIntegration'
import HolidaysByPeriodModal from '../request/HolidaysByPeriodModal.vue'

export default {
  components: {
    HolidaysByPeriodModal
  },
  inject: ['state', 'mutations'],
  data() {
    return {
      results: this.state.results,
      resultsTotal: this.state.total,
      loading: false,
      exportLoading: false,
      pagination: this.state.pagination,
      expand: false,
      headers: [
        { text: '', sortable: false },
        { text: `${this.$t('message.LicensesManager.search.nameLastname')}`, align: 'left', sortable: false, value: 'nombre' },
        {
          text: `${this.$t('message.LicensesManager.search.start')}/${this.$t('message.LicensesManager.search.return')}`,
          sortable: false,
          align: 'left',
          value: 'fecha_desde'
        },
        { text: `${this.$t('message.LicensesManager.search.days')}`, sortable: false, align: 'left', value: 'dias' },
        { text: `${this.$t('message.LicensesManager.search.type')}`, sortable: false, align: 'left', value: 'tipo' },
        { text: `${this.$t('message.LicensesManager.search.status')}`, sortable: false, align: 'left', value: 'estado' },
        { text: `${this.$t('message.LincensesHistorySummaryComponent.labels.action')}`, sortable: false, align: 'left' }
      ],
      columnSelected: '',
      orderBy: [
        {
          value: 'name',
          label: this.$t("message.LicensesManager.search.name")
        },
        {
          value: 'surname',
          label: this.$t("message.LicensesManager.search.surname")
        },
        {
          value: 'date',
          label: this.$t('message.LicensesManager.search.requestDate')
        },
        {
          value: 'dateFrom',
          label: this.$t("message.LincensesHistorySummaryComponent.labels.startDate")
        },
        {
          value: 'dateTo',
          label: this.$t("message.LincensesHistorySummaryComponent.labels.return")
        },
        {
          value: 'days',
          label: this.$t("message.LincensesHistorySummaryComponent.labels.days")
        },
        {
          value: 'type',
          label: this.$t("message.LincensesHistorySummaryComponent.labels.licenseType")
        },
        {
          value: 'status',
          label: this.$t("message.LincensesHistorySummaryComponent.labels.status")
        },
        {
          value: 'sector',
          label: this.$t('message.LicensesManager.search.sector')
        },{
          value: 'location',
          label: this.$t('message.LicensesManager.search.location')
        },
      ],
      sichernPeople: SichernPeople,
      holidayDetails: {},
      loadingDetails: {},
      activeHolidaysModal: false,
      selectedItemId: ''
    }
  },
  filters: {
    parseDetails(value){
      return value
        .replace(/{|}|"/gi, '')
        .split(',')
        .join("<br>")
    },
    woTime(value) {
      if (value === null) return ''
      return value.split(' ')[0]
    },
  },
  created() {
    this.licenses = new Licenses()
    this.sichernPeople = new SichernPeople()

  },
  computed: {
    isInIframe() {
      return this.$iframeMessages && this.$iframeMessages.isTokenValid();
    },
    primaryTextClass() {
      return this.isInIframe ? 'text-iframe-primary' : 'text-zt-primary-200';
    },
    hasVPI() {
      return this.$store.state.hasIntegrationSichernPeople
    },
    setColorByStatus(){
      return (statusId) => {
        if(statusId === '2' || statusId === '3' || statusId === '4'){
          return 'circle_warning'
        }
        if(statusId === '5'){
          return 'circle_success'
        }
        if(statusId === '10' || statusId === '9'){
          return 'circle_grey'
        }
        if(statusId === '8'){
          return 'circle_danger'
        }
      }
    }
  },
  methods: {
    handleExpandRow(props) {
      props.expanded = !props.expanded

    },
    updatePagination(pagination){
      if(this.state.pagination.totalItems){
        this.search()
      }
    },
    search(){
      this.loading = true
      const { sortBy, descending, page, rowsPerPage } = this.pagination

      this.mutations.setPagination(this.pagination)


      this.licenses
        .searchLicenses(this.state.filters, this.state.pagination.rowsPerPage, this.state.pagination.page, this.state.pagination.sortBy, this.state.pagination.descending)
        .then(response => {
          this.mutations.setResults(response.data.results.data)
          this.mutations.setTotalResults(response.data.pagination.total)
          this.pagination.totalItems = response.data.pagination.total
          this.mutations.setPagination(this.pagination)
          this.loading = false
        })
        .catch(err => {
          this.loading = false
        })
    },
    orderList(){
      this.pagination.sortBy = this.columnSelected
      this.search()
    },
    changeOrderType(){
      this.pagination.descending = !this.pagination.descending
      this.search()
    },
    exportData() {
      this.exportLoading = true
      this.mutations.setPagination(this.pagination)

      this.licenses
        .exportLicensesBlob(this.state.filters, this.state.pagination.sortBy, this.state.pagination.descending)
        .then(response => {
          const request = response.request
          const disposition = request.getResponseHeader("content-disposition")
          const size = parseInt(request.getResponseHeader('Content-Length'), 10)
          const filename = disposition.split(';')[1].split('=')[1].replace('"', '').replace('"', '')
          const ext = filename.substr(filename.lastIndexOf('.') + 1)
          let type = ''
          switch (ext) {
            case 'xls':
              type = 'application/vnd.ms-excel;charset=utf-8'
              break
            case 'zip':
              type = 'application/zip'
              break
            default:
              break
          }
          // The actual download
          const blob = new Blob([response.data], { type, size })
          if (navigator.msSaveBlob) {
            window.navigator.msSaveBlob(blob,filename)
          } else {
            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', filename)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }
          this.exportLoading = false
        })
        .catch(error => {
          this.exportLoading = false
          this.$swal({
            type: 'error',
            title: this.$t(
              `message.errorReference.${error.response.data.response_v2.code}`
            ),
            showConfirmButton: true,
            confirmButtonText: this.$t('message.settingsComponent.list.okMsg')
          })
        })
    },
    openHolidaysModal(item) {
      this.selectedItemId = item.id_licencia
      this.activeHolidaysModal = !this.activeHolidaysModal
    },
    downloadDocument(licenseId) {
      this.licenses.getUploadedDocument(licenseId)
      .then(res => {
        const data_uri_prefix = 'data:application/pdf;base64,'
        const contentDisposition = res[0].headers['content-disposition'];
        const filename = contentDisposition.split(';')[1].split('=')[1].replace('"', '').replace('"', '');
        this.pdfFile = data_uri_prefix + res[1];
        this.pdfFileName = filename;
      })
      .then(() => {
        const element = document.createElement('a');
        element.setAttribute('href', this.pdfFile);
        element.setAttribute('download', this.pdfFileName);
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@mixin circle() {
    height: 10px;
    width: 10px;
    border-radius: 5px;
    display: inline-block;
    padding-left: 1px;
    margin-right: 6px;
}
.circle_danger{
    @include circle();
    border: 2px solid #F16B6C;
    background-color: #F16B6C;
}
.circle_warning{
    @include circle();
    border: 2px solid #D39011;
    background-color: #D39011;
}
.circle_success{
    @include circle();
    border: 2px solid #54CAA6;
    background-color: #54CAA6;
}
.circle_info{
    @include circle();
    border: 2px solid #898DFF;
    background-color: #898DFF;
}
.circle_grey{
    @include circle();
    border: 2px solid #909399;
    background-color: #909399;
}
::v-deep table.v-table {
  thead th:first-child {
    padding: 0 0 0 14px;
  }
  tbody td:first-child {
    padding: 0 0 0 14px;
  }
}
.order-button {
  outline: none;
}
.link:hover {
  cursor: pointer;
}

.text-iframe-primary {
  color: #2694fc !important;
}

/* Estilos para modo iframe */
.iframe-mode {
  ::v-deep .zt-button {
    background-color: #2694fc !important;
    border-color: #2694fc !important;
    color: white !important;
    
    &:hover {
      background-color: #1e7fd4 !important;
      border-color: #1e7fd4 !important;
    }
    
    &.zt-button--outlined {
      background-color: transparent !important;
      color: #2694fc !important;
      border-color: #2694fc !important;
      
      &:hover {
        background-color: rgba(38, 148, 252, 0.1) !important;
      }
    }
  }

  ::v-deep .v-progress-linear {
    // Background del progress bar
    .v-progress-linear__background.primary {
      background-color: rgba(38, 148, 252, 0.3) !important;
    }
    
    // Barras indeterminadas con clase primary
    .v-progress-linear__bar__indeterminate.long.primary,
    .v-progress-linear__bar__indeterminate.short.primary {
      background-color: #2694fc !important;
    }
    
    // Por si acaso, también sobrescribir sin la clase primary
    .v-progress-linear__bar__indeterminate {
      &.long, &.short {
        background-color: #2694fc !important;
      }
    }
    
    // Barra determinada
    .v-progress-linear__bar__determinate {
      background-color: #2694fc !important;
    }
  }
  
  ::v-deep .v-datatable__actions {
    .v-select {
      .v-input__slot {
        color: inherit !important;
      }
      
      .v-select__selection {
        color: inherit !important;
      }
    }
  }
}

// Fix global para la lista desplegable del paginador - solo el ítem activo
::v-deep .v-menu__content {
  .v-list__tile--active {
    color: #2694fc !important;
    
    .primary--text {
      color: #2694fc !important;
    }
  }
}
</style>
